var React = require('react');

function CaretDownInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.20853 6.44088L7 12.2323L12.7915 6.44088","strokeWidth":"2"}));
}

CaretDownInline.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = CaretDownInline;

CaretDownInline.default = CaretDownInline;
